import { ITask } from 'src/interfaces/task';

export const hasMissingRequiredTaskFields = (
  task?: Pick<ITask, 'cellId' | 'operatorId'> | null
): boolean => {
  if (!task) return true;

  return !task.cellId || !task.operatorId;
};
